import { useAccountingStore } from '@/stores/accounting';
import ROUTES from '@/utils/constants/accounting/routes_names';
import USER_PERMISSIONS from '@/utils/constants/accounting/permissions_aliases';

const actions = [
    {
        routeName: ROUTES.ACCT_SETTINGS_CHART.name,
        items: [
            {
                title: 'add new account',
                routeName: ROUTES.ACCT_SETTINGS_CHART_ADD_NEW.name,
                allowed: () => {
                    const acctStore = useAccountingStore();
                    return acctStore.hasPermission(USER_PERMISSIONS.ACCT_ADD_GL_ACCOUNT);
                },
            },
        ],
    },
];

export default actions;
